import { useState, useContext } from 'react';

import LoginContext from '../../../../store/login-context';
import PreLogin from './PreLogin/PreLogin';

import Login from '../Login';
import classes from './LandingPageLogin.module.scss';
import DynamicText from '../../../General/Static/DynamicText/DynamicText';


declare function Translate(key: string): string;
declare var _siteSettings: any;
declare var _curLang: any;

export const LinkTo = (e, link) => {
    if (e.keyCode === 13 || e.keyCode === 32) window.open(link);
};

const LandingPageLogin = () => {
   
    const ctx = useContext(LoginContext);
    
    const [loginStage,setLoginStage] = useState(1);
    const [isAccountPreLogin, setIsAccountPreLogin] = useState(false);
 
    const handleAccountClick = () => {        
        setIsAccountPreLogin(true);
    }; 

    const handleAccountPress = (e) => {
        if (e.keyCode === 13 || e.keyCode === 32){
            handleAccountClick();
        }
    }
    
    const updateLoginStageHandler = (newStage:number) => {
        setLoginStage(newStage);
    }

    const continueHandler = () => {
        sessionStorage.setItem('loginAccountView','true');
        window.location.href =  _siteSettings.myAccountLink;
    }

    const cancelHandler = () => {
        setIsAccountPreLogin(false);
    }

    return(
        <>
            {!isAccountPreLogin &&
                <>
                    {/* <div className={classes.up_note}>
                        <div role="heading" aria-level={1} className={classes.title}>{Translate('N_Login_info_1')}</div>
                        <div role="heading" aria-level={2} className={classes.subTitle}>{Translate('N_Login_Sub_Title')}</div>                       
                    </div> */}

                    {/* {loginStage === 1 &&
                        <div className={classes.dynamic_text_container}>
                            <DynamicText page="otp"/>
                        </div>
                    } */}
                    

                    <div className={classes['login-wrapper-container']}>             
                        <Login isLandingPage = {true}  updateLoginStage={updateLoginStageHandler}/>                                                                  
                    </div>
                    {/* {loginStage === 1 &&
                        <div className={`${classes.footer_link_container} ${_curLang === 'ru' ? classes.footer_link_container_ru : null}`} >                                               
                            <div
                                id='accountSettings'
                                className={classes.footer_link}
                                role='link'
                                tabIndex={0}
                                onKeyDown={handleAccountPress}
                                onClick={handleAccountClick}                        
                            >
                                {Translate('N_Login_Account_Link')}
                            </div>
                            <div
                                id='accountSettingsFaq'
                                className={`${classes.footer_link} ${classes.link_2}`}
                                role='link'
                                tabIndex={0}
                                onKeyDown={(e) => LinkTo(e, _siteSettings.faqLink)}
                                onClick={() => window.open(_siteSettings.faqLink)}                       
                            >
                                {Translate('N_General_TEXT_FOOTER_FAQ')}
                            </div>           
                        </div>                
                    } */}
                </>
            }

            {isAccountPreLogin &&
                <div className={classes.pre_login_container}>
                    <PreLogin Continue={continueHandler} Cancel={cancelHandler}/> 
                </div>
            }     
                
        </>
    );
}
export default LandingPageLogin;